import React from "react";
import { useProductStore } from "../../store/productStore";
import { getGoogleDriveId } from "../../utils/generalFunction";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../ProductCard";

interface SimilarProductsProps {
  product: any;
  isShowFullScreen?: boolean;
}

const SimilarProducts: React.FC<SimilarProductsProps> = (props) => {
  const { products } = useProductStore();
  const { product, isShowFullScreen = false } = props;
  const navigate = useNavigate();

  // Filter similar products by brandName and productCategory, exclude current product
  const similarProducts = products
    .filter(
      (p: any) =>
        p.id !== product.id &&
        p.brandName === product.brandName &&
        p.productCategory === product.productCategory
    )
    .slice(0, 10);

  return (
    <div className="pb-10">
      <h3 className="font-bold text-lg my-4">Sản phẩm tương tự</h3>
      <div
        className={
          isShowFullScreen
            ? "grid grid-cols-4 gap-4 w-full"
            : "grid grid-cols-2 gap-4 w-full"
        }
      >
        {" "}
        {similarProducts.length === 0 ? (
          <></>
        ) : (
          similarProducts.map((item: any) => (
            <ProductCard
              product={item}
              key={item.id}
              onClick={() => {
                navigate(`/product-detail/${item.id}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default SimilarProducts;
